import { apiRequest } from "../../apiCall";
import { getFaxInboxPayload, getFaxOutboxPayload, sendFaxPayload } from "../../types/fax/apiRequestTypes";


export const getFaxInboxRequest = (params: getFaxInboxPayload) => apiRequest('Fax.GetFaxInbox', { ...params }, ``, true)
export const getFaxOutboxRequest = (params: getFaxOutboxPayload) => apiRequest('Fax.GetFaxOutbox', { ...params }, ``, true)
export const sendFaxRequest = (params: sendFaxPayload) => apiRequest('Fax.SendNewFax', params, ``, true)
export const getCustomerFaxNumbersRequest = () => apiRequest('Fax.GetCustomerFaxNumbers', {}, ``)
export const getCustomerHasIvrProductRequest = () => apiRequest('Fax.HasCustomerIvrProduct', {}, ``)
export const downloadFaxInboxFileRequest = (inboxId: string) => apiRequest('Fax.DownloadInboxFile', {}, `?inboxId=${inboxId}`)
export const downloadFaxOutboxFileRequest = (outboxId: string) => apiRequest('Fax.DownloadFile', {}, `?outboxId=${outboxId}`)
export const deleteFaxInboxItemRequest = (inboxItemId: string) => apiRequest('Fax.DeleteInboxItem', {}, `?inboxItemId=${inboxItemId}`)
export const resendFaxRequest = (FaxId: string) => apiRequest('Fax.ReSendFax', {}, `?FaxId=${FaxId}`, true)
export const getCustomerActiveFaxNumbersRequest = () => apiRequest('Fax.GetCustomerActiveFaxNumbers', {}, ``)



